import moment from "moment-timezone";

import { makeFetchData } from "api/makeApiRequestType/makeFetchData";
import { ValidationCallback } from "validation/validate";
import { FollowUpChecksParams } from "validation/getFieldChecker";
import { KeyValues } from "types-and-validators/KeyValues";

interface RawOutput {
	id: string;
	email: string;
	enquiryType: string;
	dateReceivedUTC: string;
	data: KeyValues;
}

const flagValidationErrors: ValidationCallback<RawOutput> = (
	input,
	{ flag, checkField }
) => {
	checkField("id", { type: "string", isRequired: true });
	checkField("email", { type: "string", isRequired: true });
	checkField("enquiryType", { type: "string", isRequired: true });
	checkField("dateReceivedUTC", { type: "datestring", isRequired: true });
	checkField("data", {
		type: "keyvalue",
		isRequired: true,
		followUpChecks: arg => {
			const { findInvalid, value } = arg as FollowUpChecksParams<"keyvalue">;
			if (Object.values(value).some(val => typeof val !== "string")) {
				findInvalid("at least one value was not a string");
			}
		}
	});
};

export const getContactFormSubmission = makeFetchData(
	"contactFormSubmission",
	flagValidationErrors,
	undefined,
	retrievedData => {
		if (!retrievedData) {
			return retrievedData;
		}

		const { dateReceivedUTC, ...rest } = retrievedData;
		return {
			...rest,
			dateReceivedUTC: moment.utc(dateReceivedUTC).toDate()
		};
	}
);
